import { OrganizationConnectionItemSort } from "@common/schemas/organization-connection-groups.schema";
import { SortSelectOption } from "@design-system/ViewTable/sorting/SortSelect";

export const DEFAULT_INTEGRATIONS_SORT = "default";

export type IntegrationsItemsSortValue =
    | OrganizationConnectionItemSort
    | typeof DEFAULT_INTEGRATIONS_SORT;

export const INTEGRATIONS_SORT_OPTIONS: Array<
    SortSelectOption<IntegrationsItemsSortValue>
> = [
    { key: DEFAULT_INTEGRATIONS_SORT, label: "Default" },
    { key: "accountNameAsc", label: "Account name (A–Z)" },
    { key: "accountNameDesc", label: "Account name (Z–A)" },
    { key: "clientNameAsc", label: "Client name (A–Z)" },
    { key: "clientNameDesc", label: "Client name (Z–A)" },
    { key: "createdAtDesc", label: "Newest connection" },
    { key: "createdAtAsc", label: "Oldest connection" },
];
